module.exports = __webpack_public_path__ + "img/hzfp31.a8140850.png";